const MIN_PASSWORD_LENGTH = 8;
const GENERATED_PASSWORD_LENGTH = 10;

const LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
const UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";
const ALL_CHARS = LOWERCASE + UPPERCASE + DIGITS;

const PASSWORD_REGEX = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{${MIN_PASSWORD_LENGTH},}$`);

function secureRandomInt(max: number): number {
  const randomValues = new Uint32Array(1);
  const maxUint32 = 0x100000000;
  const limit = maxUint32 - (maxUint32 % max);

  do {
    crypto.getRandomValues(randomValues);
  } while (randomValues[0] >= limit);

  return randomValues[0] % max;
}

export function isValidPassword(password: string): boolean {
  return PASSWORD_REGEX.test(password);
}

export function generatePassword(): string {
  const chars = [
    LOWERCASE[secureRandomInt(LOWERCASE.length)],
    UPPERCASE[secureRandomInt(UPPERCASE.length)],
    DIGITS[secureRandomInt(DIGITS.length)],
  ];

  for (let i = chars.length; i < GENERATED_PASSWORD_LENGTH; i++) {
    chars.push(ALL_CHARS[secureRandomInt(ALL_CHARS.length)]);
  }

  // Fisher-Yates shuffle
  for (let i = chars.length - 1; i > 0; i--) {
    const j = secureRandomInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join("");
}
